// Workflows: the routes and the sidebar rows of `wealth.platform.workflows` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.platform.workflows',
    routes: [
        { frontend: 'desk', path: 'workflows', lazy: () => import('@/pages/workflows/page') },
        { frontend: 'ops', path: 'workflows', lazy: () => import('@/pages/workflows/page') },
        { frontend: 'comply', path: 'workflows', lazy: () => import('@/pages/workflows/page') },
        { frontend: 'view', path: 'workflows', lazy: () => import('@/pages/workflows/page') },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'workflows',
            label: 'Workflows',
            href: '/comply/workflows',
            icon: 'Workflow',
            group: 'automation',
            order: 730,
        },
        {
            frontend: 'desk',
            key: 'workflows',
            label: 'Workflows',
            href: '/desk/workflows',
            icon: 'Workflow',
            group: 'automation',
            order: 520,
        },
        {
            frontend: 'ops',
            key: 'workflows',
            label: 'Workflows',
            href: '/ops/workflows',
            icon: 'Workflow',
            group: 'automation',
            order: 620,
        },
        {
            frontend: 'view',
            key: 'workflows',
            label: 'Workflows',
            href: '/view/workflows',
            icon: 'Workflow',
            group: 'automation',
            order: 620,
        },
    ],
});
